import { WorkspaceAction } from '@sales-app/context/workspace/workspace.actions'
import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { HomeFilters } from '@sales-app/context/workspace/workspace.type'
import { SourceQueries } from '@sales-app/graphql/queries/potentialBooking/source.queries'
import { Form, Formik } from 'formik'
import React, { FC } from 'react'

import { InputSelect } from '@/components'
import { useGraphql } from '@/hooks/useGraphql'

type Props = {
  currentFilters: HomeFilters
}

interface Option {
  label: string
  value: number
}

export const SourceSelection: FC<Props> = ({ currentFilters }) => {
  const [, WorkspaceDispatch] = useWorkspaceContext()

  const { data } = useGraphql<SourceQueries.GET_SOURCES.Response>(
    SourceQueries.getSources.name,
    SourceQueries.getSources(),
  )

  const options: Option[] =
    data && data.potentialBookingSources
      ? data.potentialBookingSources
          .filter((source) => source.manualChangeAllowed || source.id === currentFilters.source?.id)
          .map((source) => {
            return { label: source.description, value: source.id }
          })
      : []

  const onChange = (values: { sourceId: number }) => {
    const selectedSource = options.find((o) => o.value === values.sourceId)
    if (selectedSource) {
      WorkspaceDispatch(
        WorkspaceAction.updateFilters({
          source: {
            id: selectedSource.value,
            description: selectedSource.label,
          },
        }),
      )
    }
    //
  }

  return (
    <Formik
      initialValues={{
        sourceId: currentFilters.source?.id,
      }}
      onSubmit={onChange}
    >
      {({ submitForm }) => {
        return (
          <Form className="flex w-1/2 flex-row flex-wrap">
            <InputSelect
              className="w-full"
              id="sourceId"
              name="sourceId"
              onChange={submitForm}
              options={options}
              overviewDropdown={true}
            ></InputSelect>
          </Form>
        )
      }}
    </Formik>
  )
}
